import React, { Component } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import isEqual from 'lodash/isEqual'

export default class Container extends Component {
    constructor(props) {
        super(props)
        this.state = { data: props.data, index: props.index }
    }

    componentWillReceiveProps = (nextProps) => {
        if (!isEqual(nextProps.data, this.state.data)) {
            this.setState({ data: nextProps.data })
        }
    }

    shouldComponentUpdate = (nextProps) => {
        return !isEqual(nextProps.data, this.state.data)
    }
    onChangeDropdown = (currentNode, selectedNodes) => {
        var index = this.state.index
        this.props.onChange(index, currentNode, selectedNodes)
    }

    render() {
        const { data, ...rest } = this.props
        return (
            <DropdownTreeSelect data={this.state.data} onChange={this.onChangeDropdown} />
        )
    }
}
